<template>
  <div class="theme-switcher-buttons">
    <dx-button
      class="theme-button"
      styling-mode="text"
      :icon="currentTheme === 'dark' ? 'sun' : 'moon'"
      @click="toggleTheme"
      :hint="`Switch to ${currentTheme === 'dark' ? 'Light' : 'Dark'} Mode`"
    />
    <dx-button
      class="theme-button"
      styling-mode="text"
      icon="rowfield"
      @click="toggleDensity"
      :hint="`Switch to ${currentDensity === 'compact' ? 'Normal' : 'Compact'} Mode`"
    />
  </div>
</template>

<script setup>
import { DxButton } from 'devextreme-vue/button';
import { themeService } from '../theme-service';

const currentTheme = themeService.currentTheme;
const currentDensity = themeService.currentDensity;

function toggleTheme() {
  themeService.switchAppTheme();
}

function toggleDensity() {
  themeService.switchDensity();
}
</script>

<style scoped>
.theme-switcher-buttons {
  display: flex;
  gap: 6px;
}
</style>
